module.exports = __webpack_public_path__ + "static/media/ASG.bc468747.png";